import React, { useEffect, useState } from "react";
import { Mail, Trash2, Download, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminDailySubscribers() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api
      .get("/admin/daily-subscribers")
      .then(({ data }) => setData(data))
      .catch(() => setData({ total: 0, items: [] }))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Remover este inscrito?")) return;
    try {
      await api.delete(`/admin/daily-subscribers/${id}`);
      load();
    } catch {
      window.alert("Erro ao remover.");
    }
  };

  const exportCsv = () => {
    if (!data?.items?.length) return;
    const header = "name,email,source,created_at\n";
    const rows = data.items
      .map(
        (s) =>
          `"${(s.name || "").replace(/"/g, '""')}","${s.email}","${s.source || ""}","${s.created_at}"`
      )
      .join("\n");
    const blob = new Blob([header + rows], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `inscritos-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <section
      data-testid="admin-daily-subscribers"
      className="mt-14 bg-white border border-[#0B1E36]/10 p-8"
    >
      <div className="flex items-center justify-between gap-3 mb-6">
        <div className="flex items-center gap-3 text-[#C5A059]">
          <Mail size={16} strokeWidth={1.5} />
          <h2 className="text-[0.7rem] uppercase tracking-[0.28em] font-medium">
            Inscritos no conteúdo diário
          </h2>
        </div>
        <div className="flex items-center gap-3">
          <span
            data-testid="subscribers-total"
            className="font-serif-display text-[1.6rem] text-[#0B1E36] tabular-nums"
          >
            {data?.total ?? 0}
          </span>
          <button
            type="button"
            onClick={exportCsv}
            disabled={!data?.items?.length}
            className="flex items-center gap-2 bg-[#F5F7FA] hover:bg-[#ECEEF1] disabled:opacity-40 text-[#0B1E36] text-[0.68rem] uppercase tracking-[0.22em] font-medium px-3 py-2 transition-colors"
          >
            <Download size={12} strokeWidth={1.7} /> CSV
          </button>
        </div>
      </div>

      <p className="text-[0.82rem] text-[#6B7280] mb-6">
        Captura ativa. Envio automático por e-mail será habilitado quando as
        chaves da Resend forem configuradas (estrutura já preparada).
      </p>

      {loading ? (
        <div className="flex items-center py-6 text-[#6B7280]">
          <Loader2 size={16} className="animate-spin mr-2" /> Carregando…
        </div>
      ) : !data?.items?.length ? (
        <p className="py-6 text-[#6B7280] italic text-sm">
          Nenhum inscrito ainda. Eles aparecerão aqui conforme a captura na
          landing for ativa.
        </p>
      ) : (
        <ul className="divide-y divide-[#0B1E36]/8 max-h-[420px] overflow-y-auto">
          {data.items.map((s) => (
            <li
              key={s.id}
              className="flex items-center justify-between gap-3 py-3"
            >
              <div className="flex-1 min-w-0">
                <p className="text-[0.9rem] text-[#0B1E36] font-medium truncate">
                  {s.name}
                </p>
                <p className="text-[0.76rem] text-[#6B7280] truncate">
                  {s.email} · {new Date(s.created_at).toLocaleString("pt-BR")}
                </p>
              </div>
              <button
                type="button"
                onClick={() => handleDelete(s.id)}
                aria-label="Remover inscrito"
                className="w-8 h-8 flex items-center justify-center text-[#B91C1C] hover:bg-[#F5F7FA] transition-colors"
              >
                <Trash2 size={14} strokeWidth={1.7} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
